import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import LeadForm from "./components/LeadForm";
import FAQ from "./components/FAQ";
import CountdownTimer from "./components/CountdownTimer";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/inscricao" element={<LeadForm />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contador" element={<CountdownTimer />} />
      </Routes>
    </Router>
  );
}

export default App;